function sortWidthOptions() {
  const widthFieldset = document.querySelector('.picker-for--width');
  if (!widthFieldset) return;

  const inputs = [...widthFieldset.querySelectorAll('input[type="radio"]')];
  const labels = [...widthFieldset.querySelectorAll('label')];

  const pairs = inputs.map((input, i) => ({
    input,
    label: labels[i],
    value: parseFloat(input.value)
  }));

  pairs.sort((a, b) => a.value - b.value);

  observer.disconnect();
  pairs.forEach(pair => {
    widthFieldset.appendChild(pair.input);
    widthFieldset.appendChild(pair.label);
  });
  observer.observe(variantContainer, { childList: true, subtree: true });
}

const variantContainer = document.querySelector('variant-selects');
const observer = new MutationObserver(sortWidthOptions);

document.addEventListener('DOMContentLoaded', function() {
  sortWidthOptions();
  if (variantContainer) {
    observer.observe(variantContainer, { childList: true, subtree: true });
  }
});